<div class="row">
  <app-grid-item
    *ngFor="let property of properties"
    [property]="property"
    class="grid-view col-lg-4 col-md-6 col-sm-6 col-xsm-12">
  </app-grid-item>
</div>
